import * as Y from 'yjs';
import { createLiveYDoc, ydocToJSON } from '@narrativebench/editor-core';
import { API_BASE } from '../config';
import { yjsUpdateFromDocumentApi } from './document-api-yjs';
import { extractTextFromNode } from './text-extraction';
import { countWords } from './word-count';

export function countWordsFromDocumentApiPayload(payload: unknown): number {
  const bytes = yjsUpdateFromDocumentApi(payload);
  if (!bytes) return 0;
  const ydoc = createLiveYDoc();
  try {
    Y.applyUpdate(ydoc, bytes);
    const json = ydocToJSON(ydoc);
    if (!json) return 0;
    return countWords(extractTextFromNode(json));
  } finally {
    ydoc.destroy();
  }
}

export async function fetchDocumentWordCount(
  documentId: string,
  token: string | null,
  masterKey: string | null
): Promise<number> {
  const url = masterKey
    ? `${API_BASE}/api/documents/${documentId}?masterKey=${encodeURIComponent(masterKey)}`
    : `${API_BASE}/api/documents/${documentId}`;
  const response = await fetch(url, {
    headers: {
      ...(token && !masterKey ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!response.ok) return 0;
  const data: unknown = await response.json();
  return countWordsFromDocumentApiPayload(data);
}
